export default __webpack_public_path__ + "static/media/CNo.38-5.e7fd7d5f.jpg";